/**
 * Blur antd single-value Selects right after the user picks an option
 * (mouse click or Enter). Multiple/tags selects and AutoComplete keep focus
 * so the user can keep choosing or typing.
 */
const SINGLE_SELECT = '.ant-select-single:not(.ant-select-auto-complete)';

const getFocusedSingleSelectInput = () => {
  const active = document.activeElement;
  if (!active || active === document.body) {
    return null;
  }
  return active.closest(SINGLE_SELECT) ? active : null;
};

const blurLater = (element) => {
  setTimeout(() => {
    if (document.activeElement === element) {
      element.blur();
    }
  }, 0);
};

export function installSelectAutoBlur() {
  if (typeof window === 'undefined' || window.__dentristSelectAutoBlurInstalled) {
    return;
  }

  window.__dentristSelectAutoBlurInstalled = true;

  document.addEventListener('click', (event) => {
    const option = event.target?.closest?.('.ant-select-item-option');
    if (!option || option.classList.contains('ant-select-item-option-disabled')) {
      return;
    }
    const input = getFocusedSingleSelectInput();
    if (input) {
      blurLater(input);
    }
  });

  // Capture phase: the select must still be open before antd handles Enter.
  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Enter' || event.isComposing) {
        return;
      }
      const input = getFocusedSingleSelectInput();
      if (input?.closest('.ant-select-open')) {
        blurLater(input);
      }
    },
    true,
  );
}
